export * from './Component_ResourceManager.js';
//# sourceMappingURL=index.js.map